import { HarnessEngineChip, useHarnesses } from '@/features/harnesses';

/**
 * How an LLM Profile runs, in the backend's own words (e.g. "Claude Code"): the label of the harness the profile points at, found by its id in the
 * harness list. Nothing maps a type to wording here (spec 240 FR-004/FR-009), and
 * a harness that cannot be found renders nothing rather than a guess.
 */
export function RunsViaIndicator({
  harnessId,
}: {
  harnessId: string | null | undefined;
}) {
  const { entries } = useHarnesses();
  const harness = entries?.find((entry) => entry.id === harnessId);
  if (!harness?.label) return null;
  return (
    <HarnessEngineChip
      harnessType={harness.harness_type}
      label={harness.label}
    />
  );
}
